import React, { Component } from 'react'

export default class CompanyArea extends Component {
    render() {
        return (
            <>
                {/* Company Area */}
                <section className="home-company-area">
                    <div className="container">
                        <div className="row align-items-center">
                            <div className="col-lg-6 col-md-12">
                                <div className="company-content">
                                    <div className="company-tittle">
                                    <p><b>Welcome!!</b> We are Quality Digitizing services and are having 10+ year's experience in this field of SEO (Search Engine Optimization).</p>
                            
                            <p>Quality Digitizing services are offering premium quality service embroidery digitizing, vector artwork, and vector conversion since 2008. One of the best things about our company is that the prices of our work are very much cheap and affordable. We are the company that values money and this is the only reason we offer designs to the clients in turnaround time of 12 to 24 hours or sometimes less than that. Therefore, the starting price of our company is very much less in the market for these service providers. Quality and discipline are key factors of our company and this is the only thing that helps our experts to give satisfaction to the clients.</p>
                     
                                        {/* <span>Our Company</span>
                                        <h2>Innovative It Helping Service Allover the World</h2>
                                        <p>It is a long established fact that a reader will be distracted by the rea dable content of a page when looking at its layout. The point of using Lorem Ipsum is that it has a more or less normal distribution of letters, as opposed to using Content here,content here normal distribution looking at its.</p>
                                        <p>It is a long established fact that a reader will be distracted by the rea dable content of a page when looking at its layout. The point of using Lorem Ipsum is that it has a more or less normal distribution of letters, as opposed to using Content here,content here normal distribution looking at its.</p> */}
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-6 col-md-12">
                                <div className="company-img">
                                    <img src="assets/images/company/company-img.jpg" alt="company" />
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                {/* End Company Area */}
            </>
        )
    }
}
